<template>
	<view class="box">
		<view class="box-addr">
			<view class="box-addr-list">
				<view class="box-addr-list-row active">
					<image src="/static/icon/ic_wuliu_sel@2x.png" mode="widthFix"></image>
					<text>物流配送</text>
				</view>
				<view class="box-addr-list-row">
					<image src="/static/icon/ic_daodian@2x.png" mode="widthFix"></image>
					<text>门店自提</text>
				</view>
			</view>
			<!-- 物流配送 -->
			<!-- <view class="box-addr-val">
				<image class="icon1" src="/static/icon/ic_location@2x.png" mode="widthFix"></image>
				<view class="info">
					<view class="info-top">
						<text>李金平</text>
						<text>181777889338</text>
					</view>
					<view class="info-bottom">
						安徽省合肥市经开区松谷路凤凰国际B座808 豆米科技有限公司
					</view>
				</view>
				<image class="icon2" src="/static/icon/ic_ar2@2x.png" mode="widthFix"></image>
			</view> -->
			<!-- 门店自提 -->
			<view class="box-addr-val">
				<image class="icon1" src="/static/icon/ic_address@2x1.png" mode="widthFix"></image>
				<view class="info">
					<view class="info-top">
						<text>XXX经销商</text>
					</view>
					<view class="info-bottom">
						安徽省合肥市经开区松谷路凤凰国际B座808室
					</view>
				</view>
				<image class="icon2" src="/static/icon/ic_ar2@2x.png" mode="widthFix"></image>
			</view>
			<view class="box-addr-time">
				<text>营业时间：</text>
				<text>周一至周五 09:00-19:00</text>
			</view>
			<view class="box-addr-dz">
				<view class="box-addr-dz-left">
					<text>联系电话：</text>
					<text>0551-87899903</text>
				</view>
				<view class="box-addr-dz-r">
					<image src="/static/icon/ic_address@2x.png" mode="widthFix"></image>
					<text>1.3km</text>
				</view>
			</view>
		</view>
		<view class="box-shop">
			<view class="item">
				<view class="item-image">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<view class="item-info">
					<view class="item-info-title">中联艾禾宽齿 适用雷沃/中联/久保田</view>
					<view class="item-info-bottom">
						<view class="price">¥499.00</view>
						<view class="num">
							<view class="num-add">-</view>
							<view class="num-total">0</view>
							<view class="num-add">+</view>
						</view>
					</view>
				</view>
			</view>
			<view class="xian"></view>
			<view class="info">
				<view class="info-item">
					<view class="info-item-label">商品总价</view>
					<view class="info-item-price">
						<text>897</text>
						<text>.00</text>
					</view>
				</view>
				<view class="info-item">
					<view class="info-item-label">运费</view>
					<view class="info-item-price1">¥10.00</view>
				</view>
				<view class="info-item">
					<view class="info-item-label">优惠券</view>
					<view class="info-item-price1">
						-¥100.00
						<image src="/static/icon/ic_ar2@2x.png" mode="widthFix"></image>
					</view>
				</view>
				<view class="info-item">
					<view class="info-item-label">积分抵扣</view>
					<view class="info-item-price1">
						-¥10.00
						<image src="/static/icon/ic_ar2@2x.png" mode="widthFix"></image>
					</view>
				</view>
				<view class="info-item">
					<view class="info-item-label" style="color: #222222; font-size: 30rpx; font-weight: 600;">应付款</view>
					<view class="info-item-price2">
						<text>797</text>
						<text>.00</text>
					</view>
				</view>
			</view>
		</view>
		<view class="remark">
			<view class="remark-label">订单备注</view>
			<input type="text" placeholder="请输入备注" />
		</view>
		<view class="play">
			<view class="play-info">
				<image src="/static/icon/order_ic_wepay@2x.png" mode="widthFix"></image>
				<text>微信支付</text>
			</view>
			<image src="/static/icon/ic_agree@2x.png" mode=""></image>
		</view>
		<view class="footer">
			<view class="edit">
				<view class="edit-btn">立即支付 ¥799.00</view>
			</view>
			<view style="width: 100%; height: env(safe-area-inset-bottom);"></view>
		</view>
		<!-- 优惠券 -->
		<u-popup :show="show" round="15" :closeable="true" mode="bottom">
			<view class="coupon">
				<view class="coupon-title">选择优惠券</view>
				<view class="coupon-list">
					<view class="coupon-list-item">
						<view class="jiage">
							<text>100</text>
							<text>满300可用</text>
						</view>
						<view class="juaninfo">
							<view class="juaninfo-info">
								<text>新客专享</text>
								<text>2020.5.25 日到期</text>
							</view>
							<image src="/static/icon/ic_agree@2x.png" mode="widthFix"></image>
						</view>
					</view>
					<view class="coupon-list-item disable">
						<view class="jiage">
							<text>100</text>
							<text>满300可用</text>
						</view>
						<view class="juaninfo">
							<view class="juaninfo-info">
								<text>新客专享</text>
								<text>2020.5.25 日到期</text>
							</view>
							<image src="/static/icon/ic_agree@2x.png" mode="widthFix"></image>
						</view>
					</view>
				</view>
				<view class="coupon-btn">确定</view>
			</view>
		</u-popup>
		<!-- 积分 -->
		<u-popup :show="show1" round="15" :closeable="true" mode="bottom">
			<view class="coupon">
				<view class="coupon-title">使用积分</view>
				<view class="coupon-content">
					<view class="coupon-content-a">
						<text>当前积分：</text>
						<text>1200</text>
					</view>
					<view class="coupon-content-b">
						<text>本单可用积分：1000</text>
						<image src="/static/icon/ic_agree_sel@2x.png" mode="widthFix"></image>
					</view>
				</view>
				<view class="coupon-btn">确定</view>
			</view>
		</u-popup>
		<!-- 门店 -->
		<u-popup :show="show2" round="15" :closeable="true" mode="bottom">
			<view class="coupon">
				<view class="coupon-title">选择门店</view>
				<view class="coupon-search">
					<view class="coupon-search-city">
						<text>合肥市</text>
						<u-icon name="arrow-down" color="#999999" size="13"></u-icon>
					</view>
					<view class="coupon-search-input">
						<u-search placeholder="输入门店名称" height="35" searchIconColor="#999999" borderColor="#eeeeee"
							bgColor="#F9F9FB" :showAction="false" v-model="keyword" />	
					</view>
				</view>
				<scroll-view scroll-y>
					<view class="dian active" v-for="(item, index) in 10" :key="index">
						<view class="dian-top">
							<view class="dian-top-image">
								<image src="/static/logo.png" mode="widthFix"></image>
							</view>
							<view class="dian-top-info">
								<view class="dian-top-info-title">
									<text>XXX经销商</text>
									<text>距离1.2km</text>
								</view>
								<view class="dian-top-info-val">陵泉路358号红星美凯龙A馆3楼中央电梯旁P2301-P2308</view>
							</view>
						</view>
						<view class="dian-bottom">
							<text>营业时间：周一至周五 09:30-17:00</text>
							<view class="dian-bottom-icon">
								<image src="/static/icon/ic_phonecall@2x.png" mode="widthFix"></image>
								<image src="/static/icon/ic_distance@2x.png" mode="widthFix"></image>
							</view>
						</view>
					</view>
				</scroll-view>
				<view class="coupon-btn">确定选择</view>
			</view>
		</u-popup>
		<!-- 联系电话 -->
		<u-popup :show="show3" round="15" :closeable="true" mode="bottom">
			<view class="coupon">
				<view class="coupon-title">联系电话</view>
				<view class="coupon-phone">0551-87899903</view>
			</view>
		</u-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				show1: false,
				show2: false,
				show3: true,
				keyword: ''
			};
		}
	}
</script>
<style>
	page {
		background-color: #F8F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.coupon {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			scroll-view {
				width: 100%;
				max-height: 65vh;
				.active {
					border: 2rpx solid #004096 !important;
					background: #E8F2FF !important;
				}
				.dian {
					width: 100%;
					padding: 30rpx;
					box-sizing: border-box;
					border-radius: 6rpx;
					border: 1rpx solid #CCCCCC;
					display: flex;
					flex-direction: column;
					margin-bottom: 30rpx;
					&:last-child {
						margin: 0 !important;
					}
					.dian-top {
						width: 100%;
						display: flex;
						align-items: center;
						.dian-top-image {
							flex-shrink: 0;
							width: 144rpx;
							height: 144rpx;
							border-radius: 8rpx;
							margin-right: 24rpx;
							image {
								width: 100%;
							}
						}
						.dian-top-info {
							flex: 1;
							display: flex;
							flex-direction: column;
							.dian-top-info-title {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;
								text {
									&:nth-child(1) {
										font-weight: 500;
										font-size: 32rpx;
										color: #111111;
									}
									&:nth-child(2) {
										font-weight: 400;
										font-size: 24rpx;
										color: #999999;
									}
								}
							}
							.dian-top-info-val {
								width: 100%;
								margin-top: 20rpx;
								font-weight: 400;
								font-size: 26rpx;
								color: #777777;
							}
						}
					}
					.dian-bottom {
						width: 100%;
						margin-top: 30rpx;
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							font-weight: 400;
							font-size: 24rpx;
							color: #777777;
						}
						.dian-bottom-icon {
							display: flex;
							align-items: center;
							image {
								width: 56rpx;
								height: 56rpx;
								margin-left: 30rpx;
							}
						}
					}
				}
			}
			.coupon-search {
				width: 100%;
				height: 72rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 30rpx;
				.coupon-search-city {
					flex-shrink: 0;
					width: 180rpx;
					height: 72rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #F9F9FB;
					border-radius: 36rpx;
					border: 1rpx solid #EEEEEE;
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #222222;
						margin-right: 4rpx;
					}
				}
				.coupon-search-input {
					flex: 1;
					height: 100%;
					margin-left: 30rpx;
				}
			}
			.coupon-phone {
				width: 100%;
				height: 152rpx;
				line-height: 152rpx;
				text-align: center;
				font-weight: 400;
				font-size: 32rpx;
				color: #004096;
			}
			.coupon-title {
				width: 100%;
				height: 100rpx;
				line-height: 100rpx;
				text-align: center;
				font-weight: 500;
				font-size: 32rpx;
				color: #111111;
			}
			.coupon-btn {
				width: 100%;
				height: 88rpx;
				line-height: 88rpx;
				text-align: center;
				background: #004096;
				border-radius: 44rpx;
				font-weight: 500;
				font-size: 32rpx;
				color: #FFFFFF;
				margin-top: 60rpx;
			}
			.coupon-content {
				width: 100%;
				.coupon-content-a {
					width: 100%;
					margin-top: 40rpx;
					text {
						&:nth-child(1) {
							font-weight: 600;
							font-size: 28rpx;
							color: #222222;
						}
						&:nth-child(2) {
							font-weight: 600;
							font-size: 28rpx;
							color: #E4001D;
						}
					}
				}
				.coupon-content-b {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 40rpx;
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #333333;
					}
					image {
						width: 40rpx;
						height: 40rpx;
					}
				}
			}
			.coupon-list {
				width: 100%;
				display: flex;
				flex-direction: column;
				.disable {
					background: #EFEFEF !important;
					.jiage {
						text {
							color: #999999 !important;
							&::before {
								color: #999999 !important;
							}
						}
					}
					.juaninfo {
						.juaninfo-info {
							text {
								color: #999999 !important;
							}
						}
					}
				}
				.coupon-list-item {
					width: 100%;
					height: 170rpx;
					background: #FFEFEF;
					border-radius: 16rpx;
					display: flex;
					align-items: center;
					margin-bottom: 20rpx;
					&:last-child {
						margin: 0 !important;
					}
					.jiage {
						flex-shrink: 0;
						width: 208rpx;
						height: 100%;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						border-right: 1rpx dashed #E3C1C1;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 44rpx;
								color: #E4001D;
								&::before {
									content: '￥';
									font-weight: 600;
									font-size: 24rpx;
									color: #E4001D;
								}
							}
							&:nth-child(2) {
								font-weight: 400;
								font-size: 24rpx;
								color: #E93047;
								margin-top: 8rpx;
							}
						}
					}
					.juaninfo {
						flex: 1;
						height: 100%;
						padding: 0 30rpx;
						box-sizing: border-box;
						display: flex;
						align-items: center;
						image {
							flex-shrink: 0;
							width: 40rpx;
							height: 40rpx;
							margin-left: 30rpx;
						}
						.juaninfo-info {
							flex: 1;
							height: 100%;
							display: flex;
							justify-content: center;
							flex-direction: column;
							text {
								&:nth-child(1) {
									font-weight: 500;
									font-size: 32rpx;
									color: #222222;
								}
								&:nth-child(2) {
									font-weight: 400;
									font-size: 24rpx;
									color: #777777;
									margin-top: 12rpx;
								}
							}
						}
					}
				}
			}
		}
		.footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			padding: 0 30rpx;
			box-sizing: border-box;
			box-shadow: 0rpx -2rpx 4rpx 0rpx rgba(0,0,0,0.06);
			background-color: #ffffff;
			height: calc(env(safe-area-inset-bottom) + 108rpx);
			.edit {
				width: 100%;
				height: 108rpx;
				display: flex;
				align-items: center;
				.edit-btn {
					width: 100%;
					height: 88rpx;
					line-height: 88rpx;
					text-align: center;
					background: #004096;
					border-radius: 44rpx;
					font-weight: 500;
					font-size: 32rpx;
					color: #FFFFFF;
				}
			}
		}
		.play {
			width: 100%;
			height: 108rpx;
			background: #FFFFFF;
			padding: 0 26rpx;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 20rpx;
			image {
				width: 40rpx;
				height: 40rpx;
			}
			.play-info {
				display: flex;
				align-items: center;
				image {
					width: 48rpx;
					height: 48rpx;
					margin-right: 16rpx;
				}
				text {
					font-weight: 400;
					font-size: 30rpx;
					color: #111111;
				}
			}
		}
		.remark {
			width: 100%;
			height: 100rpx;
			display: flex;
			align-items: center;
			background: #FFFFFF;
			margin-top: 20rpx;
			padding: 0 26rpx;
			box-sizing: border-box;
			.remark-label {
				font-weight: 400;
				font-size: 28rpx;
				color: #333333;
				flex-shrink: 0;
				margin-right: 60rpx;
			}
			input {
				flex: 1;
				height: 100%;
				font-weight: 400;
				font-size: 28rpx;
				color: #111111;
				text-align: right;
			}
		}
		.box-shop {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			margin-top: 20rpx;
			background-color: #ffffff;
			.xian {
				width: 100%;
				height: 1rpx;
				background-color: #ECF0F4;
				margin-top: 30rpx;
			}
			.info {
				width: 100%;
				display: flex;
				flex-direction: column;
				.info-item {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 30rpx;
					.info-item-label {
						font-weight: 400;
						font-size: 28rpx;
						color: #333333;
					}
					.info-item-price1 {
						font-weight: 500;
						font-size: 28rpx;
						color: #E4001D;
						display: flex;
						align-items: center;
						image {
							width: 8rpx;
							height: 16rpx;
							margin-left: 10rpx;
						}
					}
					.info-item-price2 {
						display: flex;
						align-items: baseline;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 36rpx;
								color: #222222;
								&::before {
									content: '￥';
									font-weight: 600;
									font-size: 28rpx;
									color: #222222;
								}
							}
							&:nth-child(2) {
								font-weight: 600;
								font-size: 28rpx;
								color: #222222;
							}
						}
					}
					.info-item-price {
						display: flex;
						align-items: baseline;
						text {
							&:nth-child(1) {
								font-weight: 500;
								font-size: 32rpx;
								color: #222222;
								&::before {
									content: '￥';
									font-weight: 500;
									font-size: 28rpx;
									color: #222222;
								}
							}
							&:nth-child(2) {
								font-weight: 500;
								font-size: 28rpx;
								color: #222222;
							}
						}
					}
				}
			}
			.item {
				width: 100%;
				height: 144rpx;
				display: flex;
				align-items: center;
				.item-image {
					flex-shrink: 0;
					width: 144rpx;
					height: 144rpx;
					background: #FFFFFF;
					border-radius: 8rpx;
					border: 1rpx solid #EEEEEE;
					margin-right: 30rpx;
					image {
						width: 100%;
					}
				}
				.item-info {
					flex: 1;
					height: 144rpx;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.item-info-title {
						font-weight: 400;
						font-size: 30rpx;
						color: #222222;
					}
					.item-info-bottom {
						display: flex;
						align-items: center;
						justify-content: space-between;
						.price {
							font-weight: 600;
							font-size: 30rpx;
							color: #222222;
						}
						.num {
							display: flex;
							align-items: center;
							.num-total {
								margin: 0 32rpx;
								font-weight: 400;
								font-size: 28rpx;
								color: #222222;
							}
							.num-add {
								width: 44rpx;
								height: 44rpx;
								line-height: 44rpx;
								text-align: center;
								background: #FFFFFF;
								border-radius: 22rpx;
								border: 1rpx solid #CCCCCC;
								font-size: 40rpx;
								color: #979797;
							}
						}
					}
				}
			}
		}
		.box-addr {
			width: 100%;
			padding: 20rpx 0;
			box-sizing: border-box;
			.box-addr-list {
				width: 100%;
				height: 88rpx;
				background: #F8F9FB;
				display: flex;
				align-items: center;
				.active {
					background-color: #ffffff !important;
				}
				.box-addr-list-row {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 20rpx 20rpx 0rpx 0rpx;
					image {
						width: 30rpx;
						height: 30rpx;
						margin-right: 10rpx;
					}
					text {
						font-weight: 500;
						font-size: 30rpx;
						color: #222222;
					}
				}
			}
			.box-addr-time {
				width: 100%;
				display: flex;
				align-items: center;
				padding: 0 20rpx;
				box-sizing: border-box;
				background-color: #ffffff;
				text {
					&:nth-child(1) {
						font-weight: 400;
						font-size: 26rpx;
						color: #666666;
					}
					&:nth-child(2) {
						font-weight: 400;
						font-size: 26rpx;
						color: #333333;
					}
				}
			}
			.box-addr-dz {
				width: 100%;
				height: 80rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 20rpx;
				box-sizing: border-box;
				background-color: #ffffff;
				.box-addr-dz-left {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-weight: 400;
							font-size: 26rpx;
							color: #666666;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 26rpx;
							color: #004096;
						}
					}
				}
				.box-addr-dz-r {
					display: flex;
					align-items: center;
					image {
						width: 48rpx;
						height: 48rpx;
						margin-right: 12rpx;
					}
					text {
						font-weight: 400;
						font-size: 24rpx;
						color: #222222;
					}
				}
			}
			.box-addr-val {
				width: 100%;
				padding: 30rpx;
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				box-sizing: border-box;
				background-color: #ffffff;
				.icon1 {
					flex-shrink: 0;
					width: 48rpx;
					height: 48rpx;
					margin-right: 22rpx;
				}
				.info {
					flex: 1;
					display: flex;
					flex-direction: column;
					.info-top {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-weight: 500;
								font-size: 30rpx;
								color: #222222;
								margin-right: 14rpx;
							}
							&:nth-child(2) {
								font-weight: 400;
								font-size: 26rpx;
								color: #666666;
							}
						}
					}
					.info-bottom {
						font-weight: 400;
						font-size: 26rpx;
						color: #333333;
						margin-top: 14rpx;
					}
				}
				.icon2 {
					flex-shrink: 0;
					width: 12rpx;
					height: 24rpx;
					margin-left: 40rpx;
					margin-top: 55rpx;
				}
			}
		}
	}
</style>